export default "__VITE_ASSET__D9P3rFzi__"